import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import { HubSpotConfig } from 'modules/Integrations/integrationsConfig/hubSpot/hubspot.integration.config'

export const hubSpotConfigurationMutator = async (
  data: HubSpotConfig
): Promise<{
  success: boolean
  error: IntegrationsPortErrors | null
}> => {
  /**
   * Each version writes a disjoint set of settings through one endpoint: v2 has no
   * workflow toggle to write, and v1 has no settings card.
   */
  const res = await (data.isV2Integration
    ? dashboard20240730Client.putHubspotSettings({
        body: {
          customerImportStages: data.customerImportStages,
          signedQuoteStage: data.signedQuoteStage,
          // Out of scope right now, but as the endpoint is full-write we send the backend default.
          renewalDealCreation: 'ENABLED',
          pdfSyncOnSign: data.pdfSyncOnSign ? 'SYNC' : 'NONE',
          dealAmountSync: data.dealAmountSync ? 'SYNC' : 'NONE'
        }
      })
    : dashboardv20240509Client.putIntegration({
        service: 'HubSpot',
        body: {
          enabled: data.importCustomerWorkflow
        }
      }))

  if (res.error) {
    return {
      success: false,
      error: IntegrationsPortErrors.Other
    }
  }

  return {
    success: true,
    error: null
  }
}
